import React from 'react';
import { Outlet } from 'react-router-dom';

import Frame from '../../../components/Library/Frame';
import useTitle from '../../../libs/useTitle';
import SettingsUsersList from './SettingsUsersList';

const SettingsUsers: React.FC = () => {
  useTitle('Users');

  return <>
    <div className='p-3'>
      <div className='py-3'>
        <h2 className='text-4xl'>Users</h2>
      </div>
      <SettingsUsersList />
    </div>

    <Outlet />
  </>;
}

export default SettingsUsers;